import React, { useState } from 'react';


import TickIcon from '@icon/TickIcon';
import useStore from '@store/store';
import { ChatInterface } from '@type/chat';
import { generateUUID } from '@utils/uuid';
import { useTranslation } from 'react-i18next';


const CloneChat = React.memo(() => {
  const { t } = useTranslation();

  const setChats = useStore((state) => state.setChats);
  const setCurrentChatIndex = useStore((state) => state.setCurrentChatIndex);

  const [cloned, setCloned] = useState<boolean>(false);

  const cloneChat = () => {
    const chats = useStore.getState().chats;

    if (chats) {
      const index = useStore.getState().currentChatIndex;
      const currentChat = chats[index];

      if (!currentChat) {
        return;
      }

      let title = `Copy of ${currentChat.title}`;
      let i = 0;

      while (chats.some((chat: ChatInterface) => chat.title === title)) {
        i += 1;
        title = `Copy ${i} of ${currentChat.title}`;
      }

      const clonedChat = JSON.parse(JSON.stringify(currentChat)) as ChatInterface;
      clonedChat.id = generateUUID();
      clonedChat.title = title;
      clonedChat.viewState = { scrollTop: 0 };
      clonedChat.messages = clonedChat.messages.map((message: ChatInterface['messages'][number]) => ({
        ...message,
        id: generateUUID(),
      }));

      const updatedChats: ChatInterface[] = JSON.parse(JSON.stringify(chats));
      updatedChats.unshift(clonedChat);

      setChats(updatedChats);
      setCurrentChatIndex(useStore.getState().currentChatIndex + 1);
      setCloned(true);

      window.setTimeout(() => {
        setCloned(false);
      }, 3000);
    }
  };

  return (
    <button className='btn btn-neutral flex gap-1' onClick={cloneChat}>
      {cloned ? (
        <>
          <TickIcon /> {t('cloned')}
        </>
      ) : (
        <>{t('cloneChat')}</>
      )}
    </button>
  );
});

export default CloneChat;
